import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import HomePage from './HomePage';
import LandingPage from './LandingPage';

// What "/" shows:
//   • a tenant's own site (name.smartwater.co.ke) → straight to buying tokens, for that tenant's customers
//   • main site, first visit                      → the services page
//   • main site, returning visitor                → the token purchase page (services stay at /services)
export default function HomeGate() {
  const [tenant, setTenant] = useState(undefined);

  useEffect(() => {
    axios.get('/api/tenants/current').then((r) => setTenant(r.data.tenant || null)).catch(() => setTenant(null));
  }, []);

  if (tenant === undefined) return <div style={{ minHeight: '100vh', background: '#0b1220' }} />;
  if (tenant) return <LandingPage />;

  let seen = false;
  try { seen = localStorage.getItem('mw_seen_home') === '1'; } catch { /* private mode */ }
  return seen ? <Navigate to="/pay" replace /> : <HomePage />;
}
